<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加水点" prop="devId">
              <j-dict-select-tag
                :disabled="devIdDisAbled"
                @change="devChange"
                dictCode="`iwt-wf`.dev_list,dev_name,id,del_flag=0 order by sort asc"
                placeholder="请选择加水点"
                type="list"
                v-model="model.devId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用水企业" prop="corpId">
              <j-search-select-tag
                @change="corpChange"
                dict="`iwt-wf`.wf_consumer_corp,corp_name,id, 1=1 order by corp_name asc"
                placeholder="请选择用水企业"
                v-model="model.corpId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="班组" prop="groupId">
              <j-search-select-tag
                :dictOptions="consGroupOptions"
                @change="groupChange"
                placeholder="请选择班组"
                type="list"
                v-model="model.groupId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="取水人" prop="consumerUserId">
              <j-search-select-tag :dictOptions="consUserOptions" placeholder="请选择取水人" v-model="model.consumerUserId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="起码" prop="startVal">
              <a-input-number :min="0" placeholder="请输入起码" style="width: 100%" v-model="model.startVal" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="止码" prop="endVal">
              <a-input-number :min="0" placeholder="请输入止码" style="width: 100%" v-model="model.endVal" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划取水量" prop="planVolume">
              <a-input-number :max="30" :min="0" placeholder="请输入计划取水量" style="width: 100%" v-model="model.planVolume" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际取水量" prop="realVolume">
              <a-input-number
                :max="30"
                :min="0"
                :precision="3"
                placeholder="请输入实际取水量"
                style="width: 100%"
                v-model="model.realVolume"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始时间" prop="startTime">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择开始时间"
                style="width: 100%"
                v-model="model.startTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结束时间" prop="endTime">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择结束时间"
                style="width: 100%"
                v-model="model.endTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否结束" prop="curStatus">
              <j-switch :options="['1', '0']" v-model="model.curStatus"></j-switch>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结束原因" prop="endReason">
              <a-input placeholder="请输入结束原因" v-model="model.endReason"></a-input>
            </a-form-model-item>
          </a-col>-->
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加水时长(分钟)" prop="usedMinutes">
              <a-input-number disabled placeholder="请输入加水时长(分钟)" style="width: 100%" v-model="model.usedMinutes" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实际流速(m³/h)" prop="realFlowrate">
              <a-input-number disabled placeholder="请输入实际流速(m³/h)" style="width: 100%" v-model="model.realFlowrate" />
            </a-form-model-item>
          </a-col>-->
        </a-row>
      </a-form-model>
    </j-form-container>
    <a-tabs style="background: #fff;" type="card">
      <a-tab-pane key="1" tab="数据曲线">
        <points-line-chart ref="lineChart"></points-line-chart>
      </a-tab-pane>
      <a-tab-pane key="2" tab="APP操作记录">
        <wf-consumer-user-operation-list :filter="operationFilter" bizType="repair" @selectConsumerUser="selectConsumerUser"></wf-consumer-user-operation-list>
      </a-tab-pane>
      <a-tab-pane key="3" tab="辅助日志">
        <wf-sys-log-list :filter="operationFilter" @selectConsumerUser="selectConsumerUser"></wf-sys-log-list>
      </a-tab-pane>
    </a-tabs>
    <a-row></a-row>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import moment from 'dayjs'

  import PointsLineChart from '@views/monitor/datas/modules/PointsLineChart.vue'
  import WfConsumerUserOperationList from '@views/wf/WfConsumerUserOperationList.vue'
  import WfSysLogList from '@views/wf/modules/WfSysLogList.vue'

  export default {
    name: 'WfConsumerRecordForm',
    components: {
      PointsLineChart,
      WfConsumerUserOperationList,
      WfSysLogList
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        devIdDisAbled: false,
        model: {
          planVolume: 20,
          //   curStatus: 1,
          endReason: 1,
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/wf/wfConsumerRecord/add",
          edit: "/wf/wfConsumerRecord/edit",
          queryById: "/wf/wfConsumerRecord/queryById",

          corpGroupList: 'wf/corpGroup/list',
          corpUserList: "/custom/user/list",
          getPointslist: '/monitor/iotModelPoints/listNoValue',
        },
        consUserOptions: [],
        consGroupOptions: [],
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      operationFilter () {
        return {
          disabled: true,
          devId: this.model.devId,
          corpId: this.model.corpId,
          groupId: this.model.groupId,
          userId: this.model.consumerUserId,
          createTime_begin: moment(this.model.startTime + ':00').add(-1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
          createTime_end: moment(this.model.endTime + ':00').add(1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        }
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));

      this.getConsGroup();
      this.getConsUser();
    },
    watch: {
      // 监听 model 对象中的属性变化
      'model.startVal' (newVal) {
        if (this.model.endVal && newVal) {
          this.model.realVolume = this.model.endVal - newVal;
        }
      },
      'model.endVal' (newVal) {
        if (this.model.startVal && newVal) {
          this.model.realVolume = newVal - this.model.startVal;
        }
      },
      'model.endTime' (newVal) {
        if (newVal) {
          this.model.curStatus = 1;
          this.loadLineData()
        }
      },
      'model.startTime' (newVal) {
        if (newVal) {
          this.loadLineData()
        }
      }
    },
    methods: {
      selectConsumerUser (user) {
        if (!user || !user.id) {
          return
        }
        this.model.corpId = user.corpId;
        this.corpChange();
        this.model.groupId = user.groupId;
        this.groupChange();
        this.model.consumerUserId = user.id;
        if(user.startTime){
            this.model.startTime = user.startTime;
        }
        if(user.endTime){
            this.model.endTime = user.endTime;
        }
      },
      devChange () {
        this.loadLineData();
      },
      loadLineData () {
        const devId = this.model.devId;
        if (!devId) {
          return;
        }

        const that = this;
        getAction(this.url.getPointslist, { devId, pageSize: 9999 }).then(res => {
          if (res.success) {
            const points = res.result.records.filter(p => p.pointCode.endsWith('_36') || p.pointCode.endsWith('_34') || p.pointCode.endsWith('_32') || p.pointCode.endsWith('_23'))
            const pointsStr = points.map(p => p.pointCode).join(',');

            //曲线起止时间
            const timeRange = [moment(that.model.startTime).add(-1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
            moment(that.model.endTime).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss')]
            this.$refs.lineChart.loadData(pointsStr, timeRange)
          }
        });

      },
      corpChange () {
        this.getConsGroup();
        this.getConsUser();
      },
      groupChange () {
        this.getConsUser();
      },
      getConsGroup () {
        this.consGroupOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.model.corpId,
          column: 'groupName',
          order: 'asc',
        };
        getAction(this.url.corpGroupList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(group => {
              this.consGroupOptions.push({
                value: group.id,
                text: group.groupName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getConsUser () {
        this.consUserOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.model.corpId,
          groupId: this.model.groupId,
          column: 'username',
          order: 'asc',
        };
        getAction(this.url.corpUserList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(user => {
              this.consUserOptions.push({
                value: user.id,
                text: user.nickname
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      add (given) {
        if (given?.devId) {
          this.devIdDisAbled = true;
        }
        this.edit(Object.assign({}, this.modelDefault, given));
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        if (this.model.devId) {
          this.devIdDisAbled = true;
          this.loadLineData();
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>